import axios from "axios";
import {
  PROJECT_GET_WARRANTIES_LOADING,
  PROJECT_GET_WARRANTIES,
  PROJECT_WARRANTY_STATUS_ERROR,
  PROJECT_ADD_WARRANTY,
  PROJECT_ADD_WARRANTY_ERROR,
  PROJECT_ADD_WARRANTY_SUCCESS,
  PROJECT_DELETE_WARRANTY_SUCCESS,
  PROJECT_WARRANTY_CLEAR_SNACKBAR,
} from "../constants/types";
import queryString from "query-string";
import { bulkUploadFiles } from "./documentsActions";

import { server_url } from "../constants/types";
import request from "config/api";

export const fetchWarranties = (params = {}) => {
  return (dispatch, getState) => {
    return new Promise((resolve) => {
      dispatch({
        type: PROJECT_GET_WARRANTIES_LOADING,
        payload: {
          loading: true,
        },
      });
      const newParams = {
        PropertyId: params.PropertyId,
        ProjectId: params.ProjectId,
        PageNumber: params.page + 1,
        PageSize: params.pageSize,
      };
      const queryParams = queryString.stringify(newParams);

      request({
        url: `${server_url}/warranty?${queryParams}`,
        method: "GET",
      })
        .then((response) => {
          dispatch({
            type: PROJECT_GET_WARRANTIES,
            payload: {
              warranties: response.data.items,
              totalCount: response.data.totalCount,
              loading: false,
            },
          });
          resolve();
        })
        .catch((e) => {
          dispatch({
            type: PROJECT_WARRANTY_STATUS_ERROR,
            payload: {
              status: "error",
              message: "Error occured during getting all warranties.",
              loading: false,
              showSnackbar: true,
            },
          });
          resolve();
        });
    });
  };
};

export const addUpdateWarranty = ({
  formData,
  onSuccess,
  payload,
  updateFiles = true,
  CloseAddView = () => {},
}) => {
  return (dispatch, getState) => {
    return new Promise((resolve) => {
      dispatch({
        type: PROJECT_ADD_WARRANTY,
        payload: {
          loading: true,
        },
      });

      let data = {
        ...formData,
      };
      request({
        method: formData.warrantyId ? "PUT" : "POST",
        url: `${server_url}/warranty${
          formData.warrantyId ? `/${formData.warrantyId}` : ""
        }`,
        body: {
          ...data,
        },
      })
        .then(async (response) => {
          const { receipts1, productPhotos1, PropertyId, ProjectId } = formData;

          // Helper function to validate if a file is valid for upload
          const isValidFile = (file) => {
            if (!file) return false;

            // Handle File object
            if (file instanceof File) return true;

            // Handle FileList
            if (file instanceof FileList && file.length > 0) return true;

            // Handle file object with name property (existing uploaded files)
            if (typeof file === "object" && file !== null) {
              return Boolean(file.name || file.fileName || file.documentLabel);
            }

            // Handle base64 strings or URLs
            if (typeof file === "string" && file.trim().length > 0) return true;

            return false;
          };

          // Filter and prepare valid files for upload
          const filesToUpload = [];
          const fileLabels = [];

          if (isValidFile(receipts1)) {
            filesToUpload.push(receipts1);
            const receiptLabel =
              "rcpt_" + receipts1?.name ||
              receipts1?.fileName ||
              receipts1?.documentLabel ||
              "receipt";
            fileLabels.push(receiptLabel);
          }

          if (isValidFile(productPhotos1)) {
            filesToUpload.push(productPhotos1);
            const photoLabel =
              "prodImages_" + productPhotos1?.name ||
              productPhotos1?.fileName ||
              productPhotos1?.documentLabel ||
              "product_photo";
            fileLabels.push(photoLabel);
          }

          if (updateFiles && filesToUpload.length > 0) {
            console.log(`Uploading ${filesToUpload.length} valid file(s)`);
            try {
              dispatch(
                bulkUploadFiles(
                  filesToUpload,
                  fileLabels,
                  // [
                  //   "rcpt_" + receipts1?.name,
                  //   "prodImages_" + productPhotos1?.name,
                  // ],
                  3,
                  formData?.warrantyId || response.data.warrantyId,
                  "Warranty",
                  (payload, ...rest) => {
                    onSuccess(payload, ...rest);
                    dispatch(
                      fetchWarranties({
                        PropertyId,
                        ProjectId,
                        pageSize: 10,
                        pageNumber: 1,
                      })
                    );
                  },
                  (payload) => {
                    CloseAddView(payload);
                  }
                )
              );

              resolve();
            } catch (e) {
              CloseAddView(e);
              console.log("Error", e);
            }
          } else {
            onSuccess();
            dispatch({
              type: PROJECT_ADD_WARRANTY_SUCCESS,
              payload: {
                response: response.data,
                status: "success",
                message: "Warranty Added Successfully",
                loading: false,
                showSnackbar: true,
              },
            });
          }
        })
        .catch((e) => {
          CloseAddView();
          dispatch({
            type: PROJECT_ADD_WARRANTY_ERROR,
            payload: {
              message: "Error occured during adding Warranty data.",
              status: "error",
              loading: false,
              showSnackbar: true,
            },
          });
          resolve();
        });
    });
  };
};

export const warrantyDelete = ({
  warrantyId,
  pageModel,
  onSuccess = () => {},
  showSnackbar = true,
}) => {
  console.log("Check the warrantyDelete Action", warrantyId);
  return (dispatch, getState) => {
    return new Promise((resolve) => {
      dispatch({
        type: PROJECT_GET_WARRANTIES_LOADING,
        payload: {
          loading: true,
        },
      });
      request({
        url: `${server_url}/warranty/${warrantyId}`,
        method: "DELETE",
      })
        .then((response) => {
          if (showSnackbar) {
            dispatch({
              type: PROJECT_DELETE_WARRANTY_SUCCESS,
              payload: {
                response: response.data,
                status: "success",
                message: "Warranty Deleted Successfully",
                loading: false,
                showSnackbar: true,
              },
            });
          }
          //dispatch(fetchWarranties({ ...pageModel }));
          onSuccess();

          resolve();
        })
        .catch((e) => {
          if (showSnackbar) {
            dispatch({
              type: PROJECT_WARRANTY_STATUS_ERROR,
              payload: {
                message: "Error occured during deleteing Warranty data.",
                status: "error",
                loading: false,
                showSnackbar: true,
              },
            });
          }
          resolve();
        });
    });
  };
};

export const warrantyClearShowSnackbar = () => {
  return (dispatch, getState) => {
    dispatch({
      type: PROJECT_WARRANTY_CLEAR_SNACKBAR,
    });
  };
};
